// The UI-facing view of authentication state (brief §16).
//
// Reports WHETHER the client is authenticated and when the token expires -
// never the token or the API key. A UI component holding this object has no
// way to leak a credential because it was never given one.
export function toAuthStatus({ authenticated, expiresAt }) {
  return Object.freeze({
    authenticated: !!authenticated,
    expiresAt: expiresAt ?? null,
    expiresInMs: expiresAt ? Math.max(0, expiresAt - Date.now()) : null,
  });
}
